<template>
    <div class="columns full-width is-multiline">
        <div class="column is-12">
            <Bar :data="chartResults" :options="chartOptions" />
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import { Bar } from 'vue-chartjs'
    import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

    export default {
        props: {
            height: {},
            userId: null,
            selectedYear: null
        },

        components: {
          Bar
        },

        data() {
            return {
                yearlyData: [],
                filters: {
                    month: null
                },
                initialLoad: true,
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                chartResults: {
                  labels: [  ],
                  datasets: [ { data: [] } ]
                },
            }
        },
        watch: {
            'filters.month'(value) {
                    this.chartData()
            },
            'selectedYear' (value) {
                this.fillChart()
            }
        },

        computed: {
            //...mapGetters(['years']),
            chartOptions() {
                return{
                  responsive: true
                }
            }
        },

        mounted() {
            this.fillChart();
        },
        methods: {
            fillChart() {
                axios.get('/api/billings/user-goal', { params: { user_id : this.userId, year: this.selectedYear }})
                .then(res => {
                    this.yearlyData = res.data.data
                    this.chartData()
                    return res
                })
            },
            chartData() {
                let filterMonth = this.filters.month,
                    res = {
                        labels: filterMonth === null ? this.months : [this.months[filterMonth]],
                        datasets: []
                    },
                    colors = [
                        '#B0BC33',
                        '#F3ED3C',
                        '#044A55'
                    ]

                let currentYear = parseInt(moment().format('Y'))
                let i = 0;
                _.each(this.yearlyData, (months, year) => {
                        res.datasets.push({
                            label: year,
                            data: filterMonth ? [months[filterMonth+1]] : _.values(months),
                            backgroundColor: colors[i%colors.length]
                        })
                        i++;
                })

                this.chartResults = res
            }
        }
    }
</script>
